import { render, staticRenderFns } from "./HospitalIntroZJlinnan.vue?vue&type=template&id=9ced6c96&scoped=true"
import script from "./HospitalIntroZJlinnan.vue?vue&type=script&lang=js"
export * from "./HospitalIntroZJlinnan.vue?vue&type=script&lang=js"
import style0 from "./HospitalIntroZJlinnan.vue?vue&type=style&index=0&id=9ced6c96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ced6c96",
  null
  
)

export default component.exports